<div [sq-action-buttons]="{items: items, autoAdjust: true, rightAligned: rightAligned, size: size}"></div>